import { render, staticRenderFns } from "./AboutTeam.vue?vue&type=template&id=1af0fee0&"
import script from "./AboutTeam.vue?vue&type=script&lang=js&"
export * from "./AboutTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports